// qchat_fe/src/Component/SideData/Overview/AiAgentWorkFlow/Connectors.jsx
import React, { useState } from "react";
import OAuthConnections from "./OAuthConnections";
import ConnectorDefinitionsPanel from "./ConnectorDefinitionsPanel";
import ScopeTabs from "./ScopeTabs";
import styles from "./Connectors.module.css";

const SCOPE = {
  APP: "app",
  TENANT: "tenant",
};

const ConnectorsPage = ({ appData }) => {
  const isGlobalContext = !appData?.app_name;
  const [activeScope, setActiveScope] = useState(
    isGlobalContext ? SCOPE.TENANT : SCOPE.TENANT
  );
  const [activeTab, setActiveTab] = useState("accounts");

  if (!appData) {
    return <div>Loading...</div>;
  }

  return (
    <div className={styles.page}>
      {/* ⭐ Single, top-level ScopeTabs for the entire page */}
      <ScopeTabs
        activeTab={activeScope}
        onTabChange={setActiveScope}
        tenantCount={0} // The counts are managed inside the children, we can leave them blank here or omit if the component allows
        appCount={0}
        resourceNoun="connection"
        hiddenTabs={isGlobalContext ? ["app"] : []}
        disabled={false}
      />

      {/* Sub-tabs for the two distinct resources */}
      <div className={styles.tabBar} style={{ marginTop: 16 }}>
        <button
          type="button"
          className={`${styles.tab} ${activeTab === "accounts" ? styles.active : ""}`}
          onClick={() => setActiveTab("accounts")}
        >
          Accounts
        </button>
        <button
          type="button"
          className={`${styles.tab} ${activeTab === "actions" ? styles.active : ""}`}
          onClick={() => setActiveTab("actions")}
        >
          Actions
        </button>
      </div>

      <div className={styles.tabContent}>
        {activeTab === "accounts" ? (
          <OAuthConnections 
            appData={appData} 
            controlledScope={activeScope} 
            hideScopeTabs={true} 
          />
        ) : (
          <ConnectorDefinitionsPanel 
            appData={appData} 
            controlledScope={activeScope} 
            hideScopeTabs={true} 
          />
        )}
      </div>
    </div>
  );
};

export default ConnectorsPage;